<template>
    <div class="user-info">
        <img v-if="user_img"
            :src="$api.files.getImage($shared.getFilePath(user_img))"/>
        <span>{{ user_name }}</span>
    </div>
</template>
  
<script>

export default {
    name:'userInfoView',
    data() {
        return {
            user_name: 'No Name'
            , user_img: null
            , user_email: 'No email'
        }
    },
    components: {
        
    },
    mounted(){},
    created(){
        const userData = this.$api.users.getUserData()
        this.user_name = userData ?  userData.name : 'No Name'
        this.user_img = userData ?  userData.img_src : null
        this.user_email = userData ?  userData.email : null
        console.log(`userData=`,userData)
    }
};
</script>
<style scoped>
.user-info{
    display: flex;
    align-items: center;
}
.user-info > img {
    width: 2rem;
    margin-right: 0.5rem;
    border-radius: 20px;
}
.user-info > span {
    color:#ffffff;
    font-size: 1rem;
}
@media screen and (max-width: 1024px) {
    .user-info > img {
        margin-right: 0rem !important;
    }
    .user-info > span{
        display: none;
    }
}
</style>